import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import React, { useEffect } from 'react'
import { SelectedFiltersValues } from '../types/SelectedFilterValues'
import { WarehouseDDL } from '../../Almacen'
import { ZoneDDL } from '../../Zone'
import { TypePositionsDDL } from '../../TypePosition/TypePositionsDDL'
import { useTypePosition } from '../../../hooks'
import { ActiveDDL } from '../components/ActiveDDL'

interface ControlsSelectorProps {
  handleChangeDDLOption: any
  filtersRequest: SelectedFiltersValues
  editMode: boolean
  isUploading: Boolean
  setRequireZone: React.Dispatch<React.SetStateAction<boolean>>
}

export const ControlsSelector: React.FC<ControlsSelectorProps> = ({
  handleChangeDDLOption,
  filtersRequest,
  editMode,
  isUploading,
  setRequireZone
}) => {
  const {
    typePositionsState: { typePositions },
    getTypePositions
  } = useTypePosition()

  useEffect(() => {
    if (typePositions?.length === 0) getTypePositions()
  }, [])

  const validateSelectedTypePosition = (typePosition: number): boolean => {
    if (!editMode) {
      if (typePosition === undefined && isUploading) return true
      if (typePosition !== undefined && typePosition <= 0 && isUploading) return true
    } else {
      if (typePosition > 0) {
        const filteredTypePositions = typePositions?.filter((x) => x.typePositionId === typePosition)
        const fieldValue =
          filteredTypePositions && filteredTypePositions.length > 0
            ? filteredTypePositions[0]?.requireZone
            : false
        setRequireZone(fieldValue)
        return fieldValue
      }
    }
    return false
  }

  const valid = (id: number | undefined) => {
    if (!editMode) {
      if (id === undefined && isUploading) return true
      if (id !== undefined && id <= 0 && isUploading) return true
    }
    return false
  }

  return (
    <Box>
      <Grid container spacing={1} direction='row' sx={{ width: '100%' }}>
        <Grid size='grow'>
          <Typography variant='body2' fontWeight={700} mb={0.5} display='block'>Almacén</Typography>
          <WarehouseDDL
            onChange={handleChangeDDLOption}
            value={filtersRequest.warehouseId || -1}
            type='outlined'
            fullWidth
            key='input-warehouseId'
            required={valid(filtersRequest.warehouseId)}
          />
        </Grid>
        <Grid size='grow'>
          <Typography variant='body2' fontWeight={700} mb={0.5} display='block'>Zona</Typography>
          <ZoneDDL
            onChange={handleChangeDDLOption}
            value={filtersRequest.zoneId || -1}
            variant='outlined'
            fullWidth
            key='input-zoneId'
            warehouseId={filtersRequest.warehouseId}
            required={validateSelectedTypePosition(
              filtersRequest.typepositionId !== undefined ? filtersRequest.typepositionId : 0
            )}
          />
        </Grid>
        <Grid size='grow'>
          <Typography variant='body2' fontWeight={700} mb={0.5} display='block'>Tipo de Posición</Typography>
          <TypePositionsDDL
            onChange={handleChangeDDLOption}
            value={filtersRequest.typepositionId || -1}
            type='outlined'
            fullWidth
            key='input-typepositionId'
            required={valid(filtersRequest.typepositionId)}
            includeNotEditable={false}
          />
        </Grid>
        <Grid size='grow'>
          <Typography variant='body2' fontWeight={700} mb={0.5} display='block'>Estado</Typography>
          <ActiveDDL
            onChange={handleChangeDDLOption}
            value={filtersRequest.activeId || -1}
            variant='outlined'
            fullWidth
            key='input-active'
            required={valid(filtersRequest.activeId)}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
